/** True only once `on` has been true for `ms` milliseconds.
 *
 * A skeleton that flashes for 80 ms is noise: the table keeps its header and shows nothing in the body
 * until a read has taken long enough to need a placeholder (150 ms, the research's figure). With
 * `ms <= 0` it is just `on`, which is what a test or a caller that wants it at once passes.
 */

import { useEffect, useState } from "react";

export function useDelayedFlag(on: boolean, ms: number): boolean {
  const [late, setLate] = useState(false);
  useEffect(() => {
    if (!on || ms <= 0) return;
    const timer = window.setTimeout(() => setLate(true), ms);
    return () => {
      window.clearTimeout(timer);
      setLate(false);
    };
  }, [on, ms]);
  return ms <= 0 ? on : on && late;
}
